export const ApiUrl = `${window.location.hostname === 'localhost' ? 'http://localhost:8080' : 'https://admin.pitierra.ru'}`